import '@kerfjs/ui/select/register';

import { Checkbox } from '@kerfjs/ui/checkbox';
import { Select } from '@kerfjs/ui/select';
import { TextField } from '@kerfjs/ui/text-field';
import { type SafeHtml } from 'kerfjs';

import { type FormFieldSpec, type QuestionsDraft } from '../../data/state.js';

/** Render one typed form field, optionally prefilled from a saved draft. */
export function FormField({
  formId,
  field,
  draft,
}: {
  formId: string;
  field: FormFieldSpec;
  draft?: QuestionsDraft;
}): SafeHtml {
  const name = `f_${formId}_${field.key}`;
  const label = `${field.label}${field.required === true ? ' *' : ''}`;
  const saved = draft?.[field.key];
  if (field.type === 'boolean') {
    return (
      <Checkbox
        className="check"
        rootAttributes={{ 'data-key': field.key }}
        name={name}
        checked={saved === true}
        label={label}
      />
    );
  }
  const savedText = typeof saved === 'string' ? saved : '';
  if (field.type === 'select') {
    return (
      <Select
        name={name}
        label={label}
        value={savedText}
        choices={[{ value: '', label: '—' }, ...(field.options ?? [])]}
      />
    );
  }
  if (field.type === 'textarea')
    return (
      <TextField multiline name={name} label={label} value={savedText} rootAttributes={{ 'data-key': field.key }} />
    );
  const inputType =
    field.type === 'number' || field.type === 'currency' ? 'number' : field.type === 'date' ? 'date' : 'text';
  return (
    <TextField
      type={inputType}
      name={name}
      label={label}
      value={savedText}
      rootAttributes={{ 'data-key': field.key }}
    />
  );
}
